import React, { useState } from 'react';
import './TabView.css';
import { Row, Col } from 'react-bootstrap';

function TabView({ tabs =[]}) {
    const [activeTabIndex, setActiveTabIndex] = useState(0)

    const activateTab = (index) => {
        setActiveTabIndex(index)
    }

  return (
    <div className='tab-view'>
        <div className='body'>
            {Object.keys(tabs).length === 0 ? 
            <div>No Tabs</div>
            : (
                <div>
                    <Row>
                    <div className="tabs">
                        <div className="tabs-carosuel">
                        {tabs.map((tab, index) => (
                            
                            <Col 
                            md={2}
                            key={index}
                            htmlFor="title"
                            className={index === activeTabIndex ? 
                                'active' 
                            : 'tab' }
                            onClick={() => activateTab(index)}
                            >{tab.name}
                            <p>{tab.title}</p>
                            </Col>
                        ))}     
                        </div>
                    </div>
                    </Row>
                    <Row>
                        <Col md={6} className="scroller-icon-image" >{tabs[activeTabIndex].image}</Col>
                        <Col md={6} className="scroller-icon-content">
                        { tabs[activeTabIndex].content }                   
                        </Col>
                    </Row>     
                </div>
            )
            }
        </div>
    </div>
  )
}

export default TabView